export default __webpack_public_path__ + "static/media/Fitzroy.e88abd65.jpg";